import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";

interface Emits {
  (event: "upload", content: string, filename: string): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppUpload',
  emits: ["upload"],
  setup(__props, { emit }: { emit: ({
  (event: "upload", content: string, filename: string): void;
}), expose: any, slots: any, attrs: any }) {



/** dragging state */
const drag = ref(false);
/** input element */
const input = ref<HTMLInputElement>();

/** upload file */
async function upload(target: HTMLInputElement | DataTransfer | null) {
  /** get file name and contents from event */
  const file = (target?.files || [])[0];
  const content = (await file.text()) || "";
  const filename = file?.name || "";

  /** signal upload to parent */
  emit("upload", content, filename);

  /** reset file input */
  if (content && input.value) input.value.value = "";
}

/** on file input change */
function onChange(event: Event) {
  upload(event.target as HTMLInputElement);
}

/** on button click, click hidden file input */
function onClick() {
  input.value?.click();
}

/** on button file drop */
function onDrop(event: DragEvent) {
  drag.value = false;
  upload(event.dataTransfer);
}

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_AppButton, {
      class: "button",
      text: "Upload",
      icon: "upload",
      "data-drag": drag.value,
      onClick: onClick,
      onDragenter: _cache[0] || (_cache[0] = ($event: any) => (drag.value = true)),
      onDragleave: _cache[1] || (_cache[1] = ($event: any) => (drag.value = false)),
      onDragover: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _withModifiers(onDrop, ["prevent","stop"])
    }, null, 8, ["data-drag", "onDrop"]), [
      [_directive_tooltip, 'Choose or drag & drop a file']
    ]),
    _createElementVNode("input", {
      ref_key: "input",
      ref: input,
      "aria-label": "invisible input",
      type: "file",
      accept: "text/plain",
      style: { display: 'none' },
      onChange: onChange
    }, null, 544)
  ], 64))
}
}

})